import React, {useEffect, useState, useContext} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { Scrollbar } from 'react-scrollbars-custom';
import userlogo from "./../../../Public/img/avatar-14.jpg";
import { AuthContext } from "../../../context/AuthContext";
import logo from "./../../../Public/img/logo-black.png";


const Sidebar = ({ mobileMenuOpen, setMobileMenuOpen }) =>{

    const navigate = useNavigate();
    const currenturl = useLocation();
    const {user, setUser} = useContext(AuthContext);

    /*const [loggedname, setLoggedName] = useState("");
    const [loggedroleid, setLoggedRoleID] = useState(0);
    const [loggedemail, setLoggedEmail] = useState("");*/

    const scrollstyle = {
                        height: 'auto',
                        width: '100%',
                        position: 'right',
                        size: '7px',
                        color: '#ccc',
                        wheelStep: 10,
                        touchScrollStep: 100,
                        };

    useEffect(() =>{

        init();
		
        var $slimScrolls = $('.slimscroll');
        
        if($slimScrolls.length > 0) {
            
            var wHeight = $(window).height() - 60;
            $slimScrolls.height(wHeight);
            $('.sidebar .slimScrollDiv').height(wHeight);
            $(window).resize(function() {
                var rHeight = $(window).height() - 60;
                $slimScrolls.height(rHeight);
                $('.sidebar .slimScrollDiv').height(rHeight);
            });
        }
		

            $(document).on('mouseover', function(e) {
                e.stopPropagation();
                if ($('body').hasClass('mini-sidebar') && $('#toggle_btn').is(':visible')) {
                    var targ = $(e.target).closest('.sidebar, .header-left').length;
                    if (targ) {
                        $('body').addClass('expand-menu');
                        $('.subdrop + ul').slideDown();
                    } else {
                        $('body').removeClass('expand-menu');
                        $('.subdrop + ul').slideUp();
                    }
                    return false;
                }
            });

            if($('#btnFullscreen').length > 0) {
                document.getElementById('btnFullscreen').addEventListener('click', function() {
                    toggleFullscreen();
                });
            }
        //SlimScroll($);
        
        /*const userinfo = localStorage.getItem("userinfo");

        if(userinfo != "" && userinfo != null && userinfo != undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);
            setLoggedRoleID(loggeduserdata.role_id);
            setLoggedEmail(loggeduserdata.email);
            //console.log('User info===='+loggeduserdata);
            //console.log('User info===='+loggeduserdata.name);
        }*/

    }, []);

    const init = () =>{

		/*var Sidemenu = function() {
			this.$menuItem = $('.sidebar-menu a');
		};
		
		var $this = Sidemenu;
		$('.sidebar-menu a').on('click', function(e) {
			if($(this).parent().hasClass('submenu')) {
				e.preventDefault();
			}
			if(!$(this).hasClass('subdrop')) {
				$('ul', $(this).parents('ul:first')).slideUp(250);
				$('a', $(this).parents('ul:first')).removeClass('subdrop');
				$(this).next('ul').slideDown(350);
				$(this).addClass('subdrop');
			} else if($(this).hasClass('subdrop')) {
				$(this).removeClass('subdrop');
				$(this).next('ul').slideUp(350);
			}
		});
		$('.sidebar-menu ul li.submenu a.active').parents('li:last').children('a:first').addClass('active').trigger('click');*/
	}

	const toggleFullscreen = () =>{
		if (!document.fullscreenElement) 
		{
			document.documentElement.requestFullscreen();
		} 
		else 
		{
			if (document.exitFullscreen) 
			{
				document.exitFullscreen();
			}
		}
	}

    const handleSignout = () =>{
        localStorage.removeItem('cpmstoken');
        //sessionStorage.removeItem('cpmstoken');
        localStorage.removeItem('userinfo');

        setUser(null);

        navigate('/sign-in', { replace: true });
    }

    const handleCloseSidebar = () => {
        setMobileMenuOpen(false);

        document.documentElement.classList.remove("menu-opened");
    };

    return(
        <div className="sidebar" id="sidebar">
            <div className="crm-brand">
                <img src={logo} alt="Logo" />
                <button className="mobile-close-btn" onClick={handleCloseSidebar} >
                    <i className="ti ti-x"></i>
                </button>
            </div>
			
			<div className="sidebar-inner slimscroll">
                <Scrollbar style={scrollstyle}>
                    <div id="sidebar-menu" className="sidebar-menu">                        
                        <ul className="crm-menu-list mt-3">
                            
                            <li>
                                <Link to="/team/dashboard" className={currenturl.pathname === '/team/dashboard' ? 'active' : ''}>
                                    <i className="ti ti-home me-2"></i> <span>Dashboard</span>
                                </Link>
                            </li>
                                    
                            <li>
                                <Link to="/team/leads" className={currenturl.pathname === '/team/leads' ? 'active' : ''}>
                                    <i className="ti ti-location me-2"></i> <span>Leads</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/team/callers" className={currenturl.pathname === '/team/callers' ? 'active' : ''}>
                                    <i className="ti ti-user-circle me-2"></i> <span>Caller</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/team/remarks" className={currenturl.pathname === '/team/remarks' ? 'active' : ''}>
                                    <i className="ti ti-message me-2"></i> <span>Remarks</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/team/notifications" className={currenturl.pathname === '/team/notifications' ? 'active' : ''}>
                                    <i className="ti ti-bell me-2"></i> <span>Notifications</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/team/reports" className={currenturl.pathname === '/team/reports' ? 'active' : ''}>
                                    <i className="ti ti-chart-bar me-2"></i> <span>Report</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/team/profile" className={currenturl.pathname === '/team/profile' ? 'active' : ''}>
                                    <i className="ti ti-address-book me-2"></i> <span>Profile</span>
                                </Link>
                            </li>
                            {/*<li>
                                <div onClick={handleSignout}>
                                    <i className="ti ti-power me-2"></i> <span>Logout</span>
                                </div>
                            </li>*/}
                        </ul>

                        <div className="crm-sidebar-bottom">
                            <div className="crm-logout-link" onClick={handleSignout}>
                                <i className="ti ti-power me-2"></i>
                                <span>Log out</span>
                            </div>
                        </div>
                    </div>
                </Scrollbar>
			</div>
            
		</div>
    )
}

export default Sidebar;
